/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryProjectResponse
 */
export interface RevisdomAPIViewModelsEntryProjectResponse {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    organization?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    isPinned?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    projectId?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    status?: RevisdomAPIViewModelsEntryProjectResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    entryType?: RevisdomAPIViewModelsEntryProjectResponseEntryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    thumbnailUrl?: string | null;
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserResponse>}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    share?: Array<RevisdomAPIViewModelsUserResponse> | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    totalSizeInBytes?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryProjectResponse
     */
    childrenEntryCount?: number;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsEntryProjectResponseStatusEnum = {
    NeedsReview: 'NeedsReview',
    Updated: 'Updated',
    Approved: 'Approved'
} as const;
export type RevisdomAPIViewModelsEntryProjectResponseStatusEnum = typeof RevisdomAPIViewModelsEntryProjectResponseStatusEnum[keyof typeof RevisdomAPIViewModelsEntryProjectResponseStatusEnum];

/**
 * @export
 */
export const RevisdomAPIViewModelsEntryProjectResponseEntryTypeEnum = {
    Project: 'Project',
    Folder: 'Folder',
    File: 'File',
    Version: 'Version'
} as const;
export type RevisdomAPIViewModelsEntryProjectResponseEntryTypeEnum = typeof RevisdomAPIViewModelsEntryProjectResponseEntryTypeEnum[keyof typeof RevisdomAPIViewModelsEntryProjectResponseEntryTypeEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryProjectResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryProjectResponse(value: object): value is RevisdomAPIViewModelsEntryProjectResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryProjectResponseFromJSON(json: any): RevisdomAPIViewModelsEntryProjectResponse {
    return RevisdomAPIViewModelsEntryProjectResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryProjectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryProjectResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'organization': json['organization'] == null ? undefined : json['organization'],
        'isPinned': json['isPinned'] == null ? undefined : json['isPinned'],
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'] == null ? undefined : json['path'],
        'status': json['status'] == null ? undefined : json['status'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'share': json['share'] == null ? undefined : ((json['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'totalSizeInBytes': json['totalSizeInBytes'] == null ? undefined : json['totalSizeInBytes'],
        'childrenEntryCount': json['childrenEntryCount'] == null ? undefined : json['childrenEntryCount'],
    };
}

export function RevisdomAPIViewModelsEntryProjectResponseToJSON(json: any): RevisdomAPIViewModelsEntryProjectResponse {
    return RevisdomAPIViewModelsEntryProjectResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryProjectResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryProjectResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization': value['organization'],
        'isPinned': value['isPinned'],
        'id': value['id'],
        'projectId': value['projectId'],
        'name': value['name'],
        'path': value['path'],
        'status': value['status'],
        'entryType': value['entryType'],
        'thumbnailUrl': value['thumbnailUrl'],
        'share': value['share'] == null ? undefined : ((value['share'] as Array<any>).map(RevisdomAPIViewModelsUserResponseToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
        'totalSizeInBytes': value['totalSizeInBytes'],
        'childrenEntryCount': value['childrenEntryCount'],
    };
}

